
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import headers from './chnagesHeaders';
import { EposChangeItem } from '@/interfaces/models/EposChangeItem';

@Component
export default class ChangesTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: EposChangeItem[];
  @Prop({ type: Boolean, default: true }) public pagination!: boolean;

  public expanded: string[] = [];

  get tableHeaders() {
    return headers.map((h: ColumnHeader) => ({ ...h, text: this.$t(h.text) }));
  }
}
